import { Controller } from "@hotwired/stimulus"

// A TEXTAREA THAT GROWS WITH WHAT IS IN IT.
//
// rows="2" is a fixed height, so a long description scrolled inside two
// lines — on a phone that is most descriptions, and the text you cannot see
// is the text you are trying to edit. Cody, 12 Sep: "description cuts when
// long. it should auto resize right?"
//
// Height is set from scrollHeight, which needs the height cleared first:
// scrollHeight never reports less than the current height, so growing works
// and shrinking does not until the element is allowed to collapse.
export default class extends Controller {
  connect() {
    this.element.style.overflowY = "hidden"
    this.resize()
  }

  // A NAME IS ONE LINE OF VALUE, whatever it looks like. This is a textarea
  // so it can WRAP, not so it can hold paragraphs — a recipe name with a
  // newline in it is a name no search would match.
  preventNewline(event) {
    event.preventDefault()
  }

  resize() {
    this.element.style.height = "auto"
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
